<template>
  <div id="stepTem" class="step_tem">
    <div class="baseContentWarp" style="padding-left: 10px;">
      <p v-if="stepList.length==0" style="text-align: center;">{{ $t('yhubReport.Nodata') }}</p>
      <el-steps direction="vertical" :active="stepList.length" :space="70" finish-status="process">
        <el-step v-for="(item,index) in stepList" :key="index" :title="item.title" :description="item.description" />
      </el-steps>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    stepList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this.$nextTick(() => {
      // setTimeout(() => {
      //   [...document.querySelectorAll('.el-steps .el-step__icon div')].forEach((el, index, arr) => {
      //     el.innerHTML = arr.length - index
      //   })
      // }, 500)
      this.queryIcon()
    })
  },
  methods: {
    queryIcon() {
      setTimeout(() => {
        [...document.querySelectorAll('.el-steps .el-step__icon div')].forEach((el, index, arr) => {
          el.innerHTML = arr.length - index
        })
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.addStepPop .el-dialog {
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#stepTem .el-step__description {
  margin: 2px 0 10px;
}

.step_tem {
  background-color: #fff;
  margin: 30px 0;
}
</style>
